export const GET_UN_NUMBER_LIST = 'GET_UN_NUMBER_LIST';
export const GET_UN_NUMBER_LIST_SUCCESS = `${GET_UN_NUMBER_LIST}/SUCCESS`;
export const GET_UN_NUMBER_LIST_FAILURE = `${GET_UN_NUMBER_LIST}/FAILURE`;

export default {
  GET_UN_NUMBER_LIST,
  GET_UN_NUMBER_LIST_SUCCESS,
  GET_UN_NUMBER_LIST_FAILURE
};
